export const allCounterpartsCounterpartId = 0;
export const allCompaniesCompanyId = -1;
export const rootAccessGroupId = 1;
export const InvalidEquityAttributionId = -1;
export const myDashboardDashboardId = -1;
